/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Image_Export_Script_Name_PlaceholderInputs */



/**
* | output |
* | --- |
* | "untitled.xml" |
*
* @param {Image_Export_Script_Name_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const image_export_script_name_placeholder = /** @type {((inputs?: Image_Export_Script_Name_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Export_Script_Name_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("untitled.xml")
	if (locale === "de") return /** @type {LocalizedString} */ ("untitled.xml")
	if (locale === "it") return /** @type {LocalizedString} */ ("senza titolo.xml")
	if (locale === "ru") return /** @type {LocalizedString} */ ("untitled.xml")
	if (locale === "es") return /** @type {LocalizedString} */ ("sin título.xml")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("untitled.xml")
	if (locale === "ja") return /** @type {LocalizedString} */ ("無題.xml")
	if (locale === "hi") return /** @type {LocalizedString} */ ("शीर्षकहीन.एक्सएमएल")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("untitled.xml")
	return /** @type {LocalizedString} */ ("untitled.xml")
});